/**
 * Frequency coordination API — search 3a, "which transmitters are in use near here".
 *
 * Admin-only on the server (`require_admin` on every endpoint); the nav gate is UX.
 * In development: the response carries its own `coverage_gaps` and
 * `development_warning`, and callers are expected to render both.
 */
import api, { getErrorMessage } from './api'
import type { SitesNearResponse } from '../types'

export interface SitesNearParams {
  lat: number
  lon: number
  /** Statute miles. Capped server-side at 70 — the §90.621 co-channel figure. */
  radius_miles?: number
  /** Omit to return every assignment in the circle. */
  frequency_mhz?: number
  tolerance_khz?: number
  /**
   * Include licensees authorised across a BAND spanning the window. Defaults ON here —
   * the deliberate reverse of the renewal search's `include_band_grants`, because this
   * is the protected-party question rather than "who is on this channel".
   */
  include_band_authorisations?: boolean
  /** What this excludes comes back as `excluded_inactive`, never dropped silently. */
  active_only?: boolean
  page?: number
  page_size?: number
}

export async function sitesNear(params: SitesNearParams): Promise<SitesNearResponse> {
  try {
    const response = await api.get<SitesNearResponse>(
      '/v1/coordination/sites-near', { params },
    )
    return response.data
  } catch (error) {
    throw new Error(getErrorMessage(error))
  }
}
